<template>
    <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
        <div>
            <label class="mb-1 block text-sm font-medium text-gray-700">
                {{ $t("checkout.identity.type") }} <span class="text-red-500">*</span>
            </label>
            <select
                data-testid="guest-identity-type"
                :value="form.identityType"
                class="w-full rounded-lg border px-3 py-2 text-sm"
                :class="errors.identityType ? 'border-red-400' : 'border-gray-300'"
                @change="emitUpdate('identityType', $event.target.value)"
            >
                <option value="">{{ $t("checkout.identity.selectType") }}</option>
                <option value="KTP">{{ $t("profilePage.identityTypeOptions.ktp") }}</option>
                <option value="PASSPORT">{{ $t("profilePage.identityTypeOptions.passport") }}</option>
            </select>
            <p v-if="errors.identityType" class="mt-1 text-xs text-red-600">
                {{ errors.identityType }}
            </p>
        </div>

        <div>
            <label class="mb-1 block text-sm font-medium text-gray-700">
                {{ $t("checkout.identity.number") }} <span class="text-red-500">*</span>
            </label>
            <input
                data-testid="guest-identity-number"
                :value="form.identityNumber"
                type="text"
                class="w-full rounded-lg border px-3 py-2 text-sm"
                :class="errors.identityNumber ? 'border-red-400' : 'border-gray-300'"
                @input="emitUpdate('identityNumber', $event.target.value)"
            />
            <p v-if="errors.identityNumber" class="mt-1 text-xs text-red-600">
                {{ errors.identityNumber }}
            </p>
        </div>

        <div class="md:col-span-2">
            <GuestIdentityUpload
                data-testid="guest-identity-upload"
                :modelValue="form.identityUpload"
                @update:modelValue="emitUpdate('identityUpload', $event)"
            />
            <p v-if="errors.identityUpload" class="mt-1 text-xs text-red-600">
                {{ errors.identityUpload }}
            </p>
        </div>
    </div>
</template>

<script>
import GuestIdentityUpload from "@/components/modules/GuestIdentityUpload.vue";

export default {
    name: "IdentityVerificationSection",
    components: {
        GuestIdentityUpload,
    },
    props: {
        form: {
            type: Object,
            required: true,
        },
        errors: {
            type: Object,
            default: () => ({}),
        },
    },
    methods: {
        emitUpdate(key, value) {
            if (key === "identityUpload") {
                this.$emit("update:form", {
                    ...this.form,
                    identityUpload: value,
                    identityImageId: value?.imageId ?? null,
                });
                return;
            }
            this.$emit("update:form", {
                ...this.form,
                [key]: value,
            });
        },
    },
};
</script>
